<div [ngClass]="class"></div>
@if (countInfo) {
  <span [class]="'count-info'">{{ countInfo }}</span>
}
